import { Flex, Paper, Text } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';
import { BsArrowLeft } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  buttonLabel?: string;
}
export const NotFound = ({ title, buttonLabel }: Props) => {
  const navigate = useNavigate();
  return (
    <Paper radius={'md'} p={'md'} withBorder>
      <Flex gap={'md'} justify={'flex-start'} align={'center'} direction={'column'}>
        <Text>{title}</Text>
        {buttonLabel && (
          <PortalButton
            variant={'outline'}
            size={'xs'}
            onClick={() => navigate(-1)}
            label={buttonLabel}
            Icon={BsArrowLeft}
          />
        )}
      </Flex>
    </Paper>
  );
};
